import angular from 'angular';

import alertComponent from './alert.component';
import alertService from './alert.service';

export default angular.module('fp:customerportal:common:alert', [])
    .service('alertService', alertService)
    .component('fpAlert', alertComponent);